// extracted by mini-css-extract-plugin
module.exports = {"content":"content__3dHbu","title":"title__1kQSs","text":"text__lnH7j"};